export default __webpack_public_path__ + "static/media/flag-fr.c948d418.svg";